<template>
  <tr>
    <td v-if="MostrarAcciones">
      <div class="acciones">
        <!-- Botón reordenar -->
        <button
          v-if="mostrarArrastre"
          type="button"
          class="btn btn-secondary arrastrador"
        >
          <font-awesome-icon :icon="Icons.ORDENAR" />
        </button>
        <!-- Botón editar -->
        <button
          v-if="mostrarEditar"
          type="button"
          class="btn btn-warning"
          @click="clickEditar()"
        >
          <font-awesome-icon :icon="Icons.EDITAR" />
        </button>
        <!-- Botón eliminar -->
        <button
          v-if="mostrarEliminar"
          type="button"
          class="btn btn-danger"
          @click="clickEliminar()"
        >
          <font-awesome-icon :icon="Icons.ELIMINAR" />
        </button>
      </div>
    </td>
    <th v-if="!comercioFijo" scope="row">{{ valor.nombreComercio }}</th>
    <td v-if="valor.descuentos[0].unidad == 'x'">
      {{ String(valor.descuentos[0].descuento).split(".")[0] }}{{ valor.descuentos[0].unidad }}{{ String(valor.descuentos[0].descuento).split(".")[1] }}
    </td>
    <td v-else>
      <span>{{ valor.descuentos[0].unidad == '$' ? valor.descuentos[0].unidad : '' }}</span>{{ valor.descuentos[0].descuento }}<span>{{ valor.descuentos[0].unidad == '%' ? valor.descuentos[0].unidad : '' }}</span>
    </td>
    <td>{{ valor.nombre }}</td>
    <td>{{ valor.prioridad }}</td>
    <td>{{ valor.activo ? 'Sí' : 'No' }}</td>
    <td>{{ valor.diasHabilitados | diasSemana }}</td>
    <td>{{ valor.medioPago }}</td>
  </tr>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Icons as IconConstants } from "../../../../constants";

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    /** Cuando todos los beneficios mostrados son del mismo comercio */
    comercioFijo: Boolean,
    // Muestra u oculta los botones de acción
    // Permite arrastrar elementos para cambiar su prioridad
    mostrarArrastre: Boolean,
    mostrarEditar: Boolean,
    mostrarEliminar: Boolean,
    valor: Object,
  },
  computed: {
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    MostrarAcciones() {
      return this.mostrarArrastre || this.mostrarEditar || this.mostrarEliminar;
    },
  },
  methods: {
    clickEditar() {
      this.$emit("editar");
    },
    clickEliminar() {
      this.$emit("eliminar");
    },
  },
};
</script>
<style lang="scss" scoped>
.fila{
  td, th{
    padding: 0.5rem 0.5rem;
    vertical-align: middle;
    div{
      padding: 0px;
    }
  }
}
</style>